export function sketch(parent, p5Sound) { // we pass the sketch data from the parent
    return function (p) { // p could be any variable name
        // p5 sketch goes here

        p.restart = function(data) {
            p.n = 1;
            p.r = 100;
            p.r2 = 115;
            p.base = -90;
            p.screenCenterX = p.width / 2;
            p.screenCenterY = p.height / 2;
            p.framerate = 30
            p.speed = (360 / p.framerate) / ( data.breatheInTime + data.holdTime + data.breatheOutTime)
            p.totalTime = data.breatheInTime + data.holdTime + data.breatheOutTime
            p.breatheInTime = data.breatheInTime
            p.breatheInTimeFrames = data.breatheInTime  * p.framerate
            p.holdTime = data.holdTime
            p.holdTimeFrames = (data.holdTime * p.framerate) + p.breatheInTimeFrames;
            p.breatheOutTime = data.breatheOutTime
            p.breatheOutTimeFrames = (data.breatheOutTime * p.framerate);
            p.breatheOutTimeFramesStop = p.breatheOutTimeFrames + p.holdTimeFrames;
            p.frame = 0
            p.canvasScale = 1.0

            p.radiansSecond = 360 / p.totalTime

            p.freq = 180
            p.volume = 0

            if(p.osc !== undefined) {
                if(data.playSound == true) {
                    p.osc.start()
                } else {
                    p.osc.stop()
                } 
            }
        }

        p.setup = function () {
            let canvas = p.createCanvas(350, 320);
            canvas.parent(parent.$el);
            p.restart(parent.data)
            p.rectMode(p.CENTER);
            p.ellipseMode(p.RADIUS);
            p.frameRate(p.framerate);
            p.noFill();
            p.strokeWeight(10);
            p.stroke(255);
            p.smooth(8);
            p.textAlign(p.CENTER,p.CENTER);
            p.textSize(24);
            let myFont = p.loadFont('https://mindfuldevmag.com/fonts/nunito-v12-latin-regular.ttf');
            p.textFont(myFont);

            p.osc = new p5Sound.Oscillator('sine');
            p.osc.freq(p.freq, 0.1);
            p.osc.amp(p.volume, 0.1);

            if(parent.data.playSound == true) {
                p.osc.start()
            }
        };

        p.draw = function () {
            if (p.base === -90) {
                console.log(new Date());
            }
            p.background("#464646");
            
            p.fill("#dcdccc");
            p.frame += 1;
            p.translate(p.screenCenterX, p.screenCenterY)
            p.scale(p.canvasScale);
            p.translate(-p.screenCenterX, -p.screenCenterY)
            
            if (p.frame <= p.breatheInTimeFrames) {
                p.volume += (0.8 / p.breatheInTimeFrames)
                p.freq += (60 / p.breatheInTimeFrames)
                p.osc.freq(p.freq, 0.1);
                p.osc.amp(0.5, 0.1);
                p.canvasScale+= (0.24 / p.breatheInTimeFrames)
                p.text("inhale", p.screenCenterX, p.screenCenterY);
            } else if (p.frame <= p.holdTimeFrames) {
                p.osc.amp(0, 0.1);
                p.text("hold", p.screenCenterX, p.screenCenterY);
            } else if (p.frame <= p.breatheOutTimeFramesStop) {
                p.volume -= (0.8 / p.breatheOutTimeFrames)
                p.freq -= (60 / p.breatheOutTimeFrames)
                p.osc.freq(p.freq, 0.1);
                p.osc.amp(0.5, 0.1);
                p.canvasScale-= (0.24 / p.breatheOutTimeFrames)
                p.text("exhale", p.screenCenterX, p.screenCenterY);
            }
            
            p.strokeCap(p.SQUARE)
            p.noFill();

            p.stroke("#7f9f7f");
            var lb = -90 + (p.radiansSecond * p.breatheInTime)
            
            p.arc(p.width / 2, p.height / 2, p.r, p.r, p.radians(-90), p.radians(lb), p.OPEN);
            
            var lh = lb
            if (p.holdTime > 0) {
                lh = lb + (p.radiansSecond * p.holdTime)
                p.stroke("#dcdccc");
                p.arc(p.width / 2, p.height / 2, p.r, p.r, p.radians(lb), p.radians(lh), p.OPEN);
            }

            var lo = lh + (p.radiansSecond * p.breatheOutTime)
            p.stroke("#8faf9f");
            p.arc(p.width / 2, p.height / 2, p.r, p.r, p.radians(lh), p.radians(lo), p.OPEN);
            p.translate(p.width / 2, p.height / 2);

            var angle = p.radians(p.base + p.speed);
            p.base = p.base + p.speed;
            var x = p.cos(angle) * p.r2;
            var y = p.sin(angle) * p.r2;
            p.fill("#dca3a3");
            p.noStroke();
            p.circle(x, y, 10);

            if (p.base > 270) {
                p.base = -90;
                p.frame = 0
            }
        };

        // this is a new function we've added to p5
        // it runs only if the data changes
        p.dataChanged = function (val, oldVal) {
            p.restart(val)
            // console.log('data changed');
            // console.log('x: ', val.x, 'y: ', val.y);
        };

        p.stop = function() {
            if(p.osc !== undefined) {
                p.osc.stop()
            }
            p.remove()
        };

    };
}